import { useState } from "react";
import styled from "styled-components";
import SectionContainer from "../../container/SectionContainer";
import { Auth, UserScheme } from "client-v2";
import { Color, InputCode, Text } from "@adoptaunabuelo/react-components";
import { useSelector } from "react-redux";
import { State } from "../../../redux";
import { Player } from "@lottiefiles/react-lottie-player";

import animation from "../../../assets/animations/main-loading.json";
import { ConfirmationResult } from "firebase/auth";

const Row = styled.div`
	display: flex;
	flex-direction: row;
`;

const Code = ({ ...props }: CodeProps) => {
	const translation = useSelector(
		(state: State) => state.location.translation
	);
	const [loading, setLoading] = useState(false);

	const onNextClick = (code: string) => {
		setLoading(true);
		// Auth.loginTwilio(props.User.username, code)
		// 	.then((result) => {
		// 		props.onFinish({ data: result.data });
		// 		setLoading(false);
		// 	})
		// 	.catch((error) => {
		// 		setLoading(false);
		// 		props.onFinish({ error: error.message });
		// 	});
		Auth.login({
			confirmationResult: props.confirmationResult,
			phone: props.phone,
			code: code,
		})
			.then((result) => {
				props.onFinish({ data: result.data });
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				props.onFinish({ error: error.message });
			});
	};

	return (
		<SectionContainer
			title={"Código de verificación"}
			// subtitle={translation.code_subtitle + props.User.phone}
			subtitle={translation.code_subtitle + props.phone}
		>
			<Row>
				<InputCode
					loading={loading}
					autoFocus={true}
					onChange={onNextClick}
				/>
				{loading && (
					<Player
						style={{
							position: "absolute",
							right: 0,
							height: 120,
							width: 120,
							marginTop: -32,
						}}
						loop={true}
						autoplay={true}
						src={animation}
					/>
				)}
			</Row>
			{props.countdown && props.countdown > 0 ? (
				<Text
					type="p2"
					style={{ color: Color.text.high, marginTop: 24 }}
				>
					{translation.code_countdown_01}
					{props.countdown}
					{translation.code_countdown_02}
				</Text>
			) : null}
		</SectionContainer>
	);
};
export default Code;
export interface CodeProps {
	confirmationResult: ConfirmationResult;
	phone: string;
	// User: UserScheme;
	countdown?: number;
	onFinish: (result: { data?: UserScheme; error?: string }) => void;
}
